import React, { useMemo } from 'react';
import css from './styles.module.scss';
import { Button, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectNewSong } from '~/features/dashboard/store/selectors';
import { useHistory, useRouteMatch} from 'react-router-dom';
import { NamedForm } from '~/features/dashboard/components/add-song/components/named-form';


import { useThunkDispatch } from "~/utils/hooks/useThunkDispatch";
import { resetNewSongForm } from "~/features/dashboard/store/actions";

interface Step_7Props {
    prevStep: () => void;
}

export const Step_7: React.FC<Step_7Props> = ({ prevStep }) => {
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const newSongState = useSelector(selectNewSong);
    const dispatch = useThunkDispatch();
    const history = useHistory();

    const gotoStepSong = () => {
        history.push({
            pathname: `/creators-list/${creatorId}/dashboard/songs/add-song`,
            state: {
                gotoStep: 1,
            },
        });
        dispatch(resetNewSongForm());
    };

    return (
        <NamedForm name={newSongState?.gSongName} onSubmit={() => console.log('')}>
            <div className={css.module}>
                <Typography className={css.bold}> COMPLETE !</Typography>
                <Button onClick={gotoStepSong} className={css.addAnother}>
                    Add Another
                </Button>
            </div>
        </NamedForm>
    );
};
